export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa28f4a1b25c8d99d1da88ebb98b297da506bc4fc&name=fetchTypeahead!'